// extracted by mini-css-extract-plugin
export default {"accountHeader":"hs-z","primeBadge":"is-z","logout":"js-z"};